import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const ContainerSearchTerms = styled.div`
    position: relative;

    & label {
        display: none;
    }

    & #searchTerms::placeholder { 
        color: #5B5B5FBF;
    }

    & > div {
        margin: 0;
    }

    & input {
        width: 426px;
    }
`;

export const Container = styled.div`
    position: sticky;
    top: 0px;
    z-index: 999;

    display: flex;
    flex: 1 1 100%;
    align-items: center;
    justify-content: space-between;
    
    margin-top: 0;
    margin-bottom: 0;
    height: 76px;
    padding: 0 32px;
    border-bottom: 1px solid ${(props) => props.theme.highLightGrey};
    color: #5B5B5F;
    background: ${(props) => props.theme.white};

    h2 {
        font-weight: bold;
        font-size: ${theme.font.size20};
    }

    .menu-info-mobile {
        display: flex;
        align-items: center;

        img {
            width: 50px;
            margin-left : 6px;
        }
    }

    @media(max-width: 600px) {
        height: 56px;
        padding: 0 16px;

        .menu-info-mobile {
            svg {
                font-size: ${theme.font.size26} !important;
            }
        }

        .user-image {
            width: 30px;
            height: 30px;
        }

        .logo-mobile {
            width: 40px !important;
        }
    }
`;

export const UserInfo = styled.div`
    display: flex;
    align-items: center;

    img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-left: 10px;
    }

    .user-dropdown {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;
        user-select: none;
        
        .user-name {
            font-size: ${theme.font.size16};
            font-weight: bold;
            color: ${(props) => props.theme.greyLink};
            margin-left: 10px;
            white-space: nowrap;
        }

        span[class*="material-icons"] {
            margin-left: 4px;
        }

        .dropdown {
            position: absolute;
            bottom: -40px;
            right: 0;
        }
    }

`;

export const DateText = styled.div`
    font: ${theme.font.body[5]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.grey};
`;

export const TextInput = styled.div`
    color: ${(props) => props.theme.greyLink};
    font-size: ${theme.font.size16};
`;
